import { cn } from '@/lib/utils'
import type { ReactNode } from 'react'

type SectionVariant = 'default' | 'light' | 'dark' | 'primary'

interface SectionProps {
  children: ReactNode
  className?: string
  variant?: SectionVariant
}

const variantStyles: Record<SectionVariant, string> = {
  default: 'bg-white border-t-4 border-brand-red',
  light: 'bg-[#F9F6F1] border-t-4 border-brand-red',
  dark: 'bg-brand-dark text-white border-t-4 border-brand-red',
  primary: 'bg-brand-red text-white border-t-4 border-white/40',
}

export function Section({ children, className, variant = 'default' }: SectionProps) {
  return (
    <section className={cn('py-20 md:py-28', variantStyles[variant], className)}>
      {children}
    </section>
  )
}
